import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import LeaderboardRoundedIcon from '@mui/icons-material/LeaderboardRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { useCallback } from 'react';
import { createGetRecentTourneyWinnersOutbound, createGetUpcomingTourneysOutbound } from '../api/outbound/commonOutbounds';
import { ExpandableSection } from '../components/expandableSection';
import { useSocketSend } from '../context/webSocket/webSocketContext';
import { addMessageBox } from '../redux/actions/messageBoxesActions';
import { useAppDispatch } from '../redux/store';
import { DrawerButton } from './drawerButton';
import { ExpandableSectionPaddedDrawerContainer } from './drawerControl';
export const TourneysExpandableDrawerSection = ({ closeDrawer }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickUpcomingTourneys = useCallback(() => {
        socketSend(createGetUpcomingTourneysOutbound());
        closeDrawer();
    }, [closeDrawer, socketSend]);
    const onClickTourneyCalendar = useCallback(() => {
        dispatch(addMessageBox({ type: 'tourney-calendar' }));
        closeDrawer();
    }, [closeDrawer, dispatch]);
    const onClickRecentTourneyWinners = useCallback(() => {
        closeDrawer();
        socketSend(createGetRecentTourneyWinnersOutbound());
    }, [closeDrawer, socketSend]);
    return (_jsx(ExpandableSection, { expandableSectionType: 'drawer-tourneys', colorType: 'drawer', children: _jsxs(ExpandableSectionPaddedDrawerContainer, { children: [_jsx(DrawerButton, { label: 'Upcoming Tourneys', onClick: onClickUpcomingTourneys, startIcon: _jsx(ScheduleRoundedIcon, {}) }), _jsx(DrawerButton, { label: 'Tourney Calendar', onClick: onClickTourneyCalendar, startIcon: _jsx(CalendarMonthRoundedIcon, {}) }), _jsx(DrawerButton, { label: 'Recent Tourney Winners', onClick: onClickRecentTourneyWinners, startIcon: _jsx(LeaderboardRoundedIcon, {}) })] }) }));
};
